module.exports = __webpack_public_path__ + "assets/d2576b0f7386a7656b4ff1a1b210f553.png";